import { SkillType } from "~/types/SkillLevel";
import { Database } from "~/types/supabase";

export const getSkillStageByLevel = (level: number) => {
  return level % 2 === 0 ? level / 2 : Math.floor(level / 2) + 1;
};

export const transformDbUserSkillLevelToSkillType = (
  userSkills: Database["public"]["Tables"]["user_skills"]["Row"],
  dbSkillLevels: {
    created_at: string | null;
    description: string;
    id: string;
    name: Database["public"]["Enums"]["Skills"];
    skill_levels: {
      id: number;
      level: number;
      xp_required: number;
      created_at: string;
    }[];
  }
): SkillType => {
  const maxLevel = dbSkillLevels.skill_levels.length;
  return {
    name: dbSkillLevels.name,
    level: userSkills.level,
    currentXP: userSkills.xp,
    currentLevelRequiredXP:
      dbSkillLevels.skill_levels[Math.min(userSkills.level, maxLevel) - 1]
        .xp_required,
    nextLevelRequiredXP:
      dbSkillLevels.skill_levels[Math.min(userSkills.level, maxLevel - 1)]
        .xp_required,
    description: dbSkillLevels.description,
  };
};

export const getFrameStrengthText = (strength: number) => {
  switch (strength) {
    case 1:
      return "Fragile";
    case 2:
      return "Weak";
    case 3:
      return "Solid";
    case 4:
      return "Unshakeable";
    default:
      return "Unknown";
  }
};

export const convertHumorTypeFromTypedResponseToDisplayText = (
  humorType: string
): string => {
  switch (humorType) {
    case "sarcasm":
      return "Sarcasm";
    case "selfDeprecating":
      return "Self-Deprecating";
    case "dark":
      return "Dark";
    case "situational":
      return "Situational";
    case "absurd":
      return "Absurd";
    case "comeback":
      return "Comeback";
    default:
      return "Unknown";
  }
};
